/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function _initBackgroundVideo($container) {
    if ($container.length) {
        var assessBackgroundVideo = function assessBackgroundVideo() {
            var $container = this,
                cw = $container.width(),
                ch = $container.height(),
                cr = cw / ch,
                $frame = $(".VideoWrapper iframe", this),
                vr = $frame.attr("width") / $frame.attr("height"),
                $pan = $(".VideoWrapper", this),
                vCrop = 75;

            if (cr > vr) {
                var vh = cw / vr + vCrop * 2;
                $pan.css({
                    marginTop: (ch - vh) / 2 - vCrop,
                    marginLeft: "",
                    height: vh + vCrop * 2,
                    width: "",
                });
            } else {
                var vw = cw * vr + vCrop * 2 * vr;
                $pan.css({
                    marginTop: -vCrop,
                    marginLeft: (cw - vw) / 2,
                    height: ch + vCrop * 2,
                    width: vw,
                });
            }
        };

        $(window).on("load", assessBackgroundVideo.bind($container));
        $(window).on("resize", assessBackgroundVideo.bind($container));
    }
}
_initBackgroundVideo($(".section-background-video .VideoWrapper__container"));


(function (ns, fetch) {
    if (typeof fetch !== 'function') return;

    ns.fetch = function () {
        const response = fetch.apply(this, arguments);

        response.then(res => {
            if ([
                `${window.location.origin}/cart/update.js`,
                `${window.location.origin}/cart/change.js`,
                `${window.location.origin}/cart/clear.js`,
            ].includes(res.url)) {
                const renderCartEvent = new CustomEvent("rendered-cart");
                window.dispatchEvent(renderCartEvent);
                res.clone().json().then(data => {
                    if (data.item_count < 1) {
                        $('.cart-link__count').removeClass("is-visible");
                    } else {
                        $('.cart-link__count').addClass("is-visible");
                    }
                    $('.cart-link__count').html(data.item_count);
                });
            } else if ([
                `${window.location.origin}/cart/add.js`
            ].includes(res.url)) {
                const renderCartEvent = new CustomEvent("rendered-cart");
                window.dispatchEvent(renderCartEvent);
                $.getJSON('/cart.js', function (cart) {
                    $('.cart-link__count').addClass("is-visible");
                    $('.cart-link__count').html(cart.item_count);
                });
            }
        });

        return response;
    }

}(window, window.fetch))

// See password
var see_password_btn_1 = $("#sidebar-cart #see_password_btn");
var see_password_btn_2 = $("#main #see_password_btn");
see_password_btn_1.on('click', function (event) { seePassword(event, see_password_btn_1) });
see_password_btn_2.on('click', function (event) { seePassword(event, see_password_btn_2) });

function seePassword(e, see_password_btn) {
    e.preventDefault();
    var password_input = see_password_btn.parent().find(".Form__Input[name='customer[password]']");
    var eye_icon = see_password_btn.parent().find(".Form__Item--see_password svg[name='eye']");
    var crossed_eye_icon = see_password_btn.parent().find(".Form__Item--see_password svg[name='crossed_eye']");
    if (password_input && eye_icon && crossed_eye_icon) {
        if (password_input.attr('type') == "password") {
            password_input.attr('type', "text");
            eye_icon.hide();
            crossed_eye_icon.css("display", "unset");
        } else if (password_input.attr('type') == "text") {
            password_input.attr('type', "password");
            crossed_eye_icon.hide();
            eye_icon.css("display", "unset");
        }
    }
}

// On scroll fixed header
var header = document.querySelector(".shopify-section--header");

window.addEventListener('scroll', onScroll);

function onScroll() {
    if (!header) return;
    var top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if (top >= 1) {
        document.querySelector("#section-header")?.classList.remove("Header--transparent");
        header.classList.add("fixed");
    } else {
        header.classList.remove("fixed");
    }
}

onScroll();

Flickity.prototype._createResizeClass = function () {
    this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
};

// Stip p tags around img tags
var imgs = document.querySelectorAll(".Article__Body img, .PageContent img");

if (imgs.length > 0) {
    imgs.forEach(stripPTag);
}

function stripPTag(el) {
    var parent = el.parentNode;
    if (parent.nodeName === 'DIV') {
        return;
    }
    if (parent.nodeName !== 'P') {
        parent = parent.parentNode;
    }
    parent.parentNode.insertBefore(el, parent);
    parent.parentNode.removeChild(parent);
}


// Hack to add collections to pages page content
var pageBody = document.querySelector(".PageContent");
var articleBody = document.querySelector(".Article__Body");
var pageContent = pageBody ? pageBody : articleBody;
var collection1 = document.querySelector("#collection1");
var collection2 = document.querySelector("#collection2");
var collection3 = document.querySelector("#collection3");
if (pageContent && collection1 && pageContent.innerHTML.indexOf("[collection1]") !== -1) {
    var newPageContent = pageContent.innerHTML.replace("[collection1]", collection1.outerHTML);
    collection1.remove();
    pageContent.innerHTML = newPageContent;
    document.querySelector("#collection1").style.display = "flex";
    if (collection2 && newPageContent.indexOf("[collection2]") !== -1) {
        newPageContent = pageContent.innerHTML.replace("[collection2]", collection2.outerHTML);
        collection2.remove();
        pageContent.innerHTML = newPageContent;
        document.querySelector("#collection2").style.display = "flex";
    }
    if (collection3 && newPageContent.indexOf("[collection3]") !== -1) {
        newPageContent = pageContent.innerHTML.replace("[collection3]", collection3.outerHTML);
        collection3.remove();
        pageContent.innerHTML = newPageContent;
        document.querySelector("#collection3").style.display = "flex";
    }
}

// Newsletter show page overlay
var newsletter = document.querySelector(".NewsletterPopup");
if (newsletter) {
    var newsletterOptions = JSON.parse(newsletter.getAttribute('data-section-settings'));
    var newsletterClose = document.querySelector(".NewsletterPopup__Close");
    var newsletterBtn = document.querySelector(".Newsletter__Subscribe");
    var pageOverlay = document.querySelector(".PageOverlay");

    function closeNewsletter() {
        pageOverlay.classList.remove("is-visible");
        document.documentElement.classList.remove("no-scroll");
        newsletter.setAttribute("aria-hidden", "true");
        pageOverlay.removeEventListener("click", closeNewsletter);
        newsletterClose.removeEventListener("click", closeNewsletter);
    }

    function openNewsletter() {
        pageOverlay.classList.add("is-visible");
        document.documentElement.classList.add("no-scroll");
        newsletter.setAttribute("aria-hidden", "false");
        pageOverlay.addEventListener("click", closeNewsletter);
        newsletterClose.addEventListener("click", closeNewsletter);
    }

    newsletterBtn.addEventListener("click", openNewsletter);
}

try {
    if (window.location.hash === '#newsletter-popup') {

        pageOverlay.classList.add("is-visible");
        document.documentElement.classList.add("no-scroll");
        pageOverlay.addEventListener("click", closeNewsletter);
        newsletterClose.addEventListener("click", closeNewsletter);

    } else if (!newsletterOptions['showOnlyOnce'] || newsletterOptions['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
        setTimeout(function () {
            pageOverlay.classList.add("is-visible");
            document.documentElement.classList.add("no-scroll");
        }, newsletterOptions["apparitionDelay"] * 1000);

        pageOverlay.addEventListener("click", closeNewsletter);
        newsletterClose.addEventListener("click", closeNewsletter);
    }
} catch (error) {
    // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
}

// fix storelocator iframe
var videoWrapper = Array.from(document.querySelectorAll(".VideoWrapper"));

if (videoWrapper.length > 0) {
    videoWrapper.forEach(setStorePadding);
}

function setStorePadding(el) {
    var iframe = el.children[0];
    var iframeSrc = iframe.getAttribute("src") || iframe.getAttribute("data-src");
    if (iframeSrc && iframeSrc.indexOf("storelocator") !== -1) {
        el.classList.add("no-padding");
    }
}

// add number to last thumbnail image on products
var productThumbs = document.querySelector(".Product__SlideshowNavScroller");
if (productThumbs) {
    var count = productThumbs.childElementCount;
    if (count > 4) {
        var thumb = productThumbs.children[3];
        var div = document.createElement("div");
        div.classList.add("plus");
        div.innerHTML = "+" + (count - 4);
        thumb.children[0].appendChild(div);
    }
}

// open cart drawer
var path = window.location.pathname;
var sidebarCart = document.querySelector("#sidebar-cart");
var cartCloseBtn = document.querySelector(".Drawer__Close");

// close cart drawer on login
var login_form = document.getElementById("customer_login");
if (login_form) {
    login_form.addEventListener("submit", onLogin);
}

function onLogin() {
    localStorage.removeItem("openCartInfoLogin");
}

// prevent default on menuitems with menu menu
var menuItems = Array.from(document.querySelectorAll(".HorizontalList__Item"));
if (menuItems.length > 0) {
    menuItems.forEach(disableClick);
}

function disableClick(el) {
    if (el.getAttribute("aria-haspopup")) {
        el.children[0].addEventListener('click', function (e) {
            e.preventDefault();
        })
    }
}

// open right tab on read more click (product template)
var readMore = document.querySelector("#readMore");
if (readMore) {
    readMore.addEventListener("click", function (e) {
        e.preventDefault();
        var id = readMore.getAttribute("href");
        var tab = document.querySelector(id);
        open(tab);
    })
}

// open read more on mobile (product template)
var readProductDescriptionSmall = document.querySelector("#ProductDescriptionBtnSmall");
if (readProductDescriptionSmall) {
    readProductDescriptionSmall.addEventListener("click", function (e) {
        e.preventDefault();
        var id = readProductDescriptionSmall.getAttribute("href");
        var tab = document.querySelector(id);
        setTimeout(function () {
            open(tab);
        }, 100);
    })
}

function open(tab) {
    var toggleButton = tab.querySelector(".Collapsible__Button");
    var collapsibleInner = tab.querySelector(".Collapsible__Inner");

    if (!collapsibleInner || toggleButton.getAttribute("aria-expanded") === "true") {
        return; // It's already open
    }

    toggleButton.setAttribute("aria-expanded", "true");
    collapsibleInner.style.height = "auto";
}

// add read more functionality on collection descriptions
var showChar = 250;
var ellipsisText = "...";
var desc = document.querySelector(".CollectionMain__Description");

if (desc) {
    var moreText = desc.getAttribute("data-more");
    var lessText = desc.getAttribute("data-less");
    initReadMore(desc);
}

function initReadMore(desc) {
    desc.style.height = "auto";
    if (desc.children.length > 1) {

        var readMore = document.createElement("span");
        readMore.innerHTML = '<span class="ellipsis">' + ellipsisText + '</span><a href="#" class="morelink">' + moreText + "</a>";

        desc.children[0].append(readMore);
        desc.querySelector(".morelink").addEventListener('click', toggleReadMoreMultiple);
    } else {
        var content = desc.innerHTML;
        if (content.length > showChar) {
            var excerpt = content.substr(0, showChar);
            var hidden = content.substr(showChar, content.length - showChar);

            var html = excerpt + '<span class="ellipsis">' + ellipsisText + '</span><a href="#" class="morelink">' + moreText + '</a><span class="more hidden">' + hidden + "</span>";

            desc.innerHTML = html;
            desc.querySelector(".morelink").addEventListener('click', toggleReadMoreSingle);
        }
    }
}

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function toggleReadMoreMultiple(e) {
    e.preventDefault();
    var btn = e.target;
    var ellipsis = desc.querySelector(".ellipsis");
    var moreLink = desc.querySelector(".morelink");
    if (btn.classList.contains('open')) {
        btn.classList.remove('open');
        btn.innerHTML = moreText;
        insertAfter(moreLink, ellipsis);
    } else {
        btn.classList.add('open');
        btn.innerHTML = lessText;
        desc.children[desc.children.length - 1].append(moreLink);
    }
    desc.classList.toggle("open");
    ellipsis.classList.toggle("hidden");
}

function toggleReadMoreSingle(e) {
    e.preventDefault();
    var btn = e.target;
    var more = desc.querySelector(".more");
    var ellipsis = desc.querySelector(".ellipsis");
    var moreLink = desc.querySelector(".morelink");
    if (btn.classList.contains('open')) {
        btn.classList.remove('open');
        btn.innerHTML = moreText;
        insertAfter(moreLink, ellipsis);
    } else {
        btn.classList.add('open');
        btn.innerHTML = lessText;
        more.append(moreLink);
    }
    more.classList.toggle('hidden');
    ellipsis.classList.toggle("hidden");
}

$(document).ready(function() {
    $('#customreview-slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        draggable: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
    });
  $('#category-product-list-custom, #category-product-list-custom11').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        draggable: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
    });
  
    $('#custom-collection-product-meta').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        draggable: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
    });
  
    $('#custom-collection-meta-collection').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        draggable: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
    });

  
}); 